import React from 'react';
import { SectionInstance } from '../types';
import InlineEditText from '../InlineEditText';
import { renderSbIcon } from '../IconPickerField';
import { sfHeadline, sfSub } from './sectionHelpers';

interface Props {
  section: SectionInstance;
}

const FeaturesGrid: React.FC<Props> = ({ section }) => {
  const c = section.controls;
  const features = (c.features || []) as Array<{ icon: string; title: string; description: string }>;
  const variant = c.variant || '3_col';
  const cols = variant === '4_col' ? 4 : variant === '2_col' ? 2 : 3;

  return (
    <section className="sb-render sb-render-features-grid" style={{ padding: '80px 24px' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: 48 }}>
          {c.section_label && (
            <span style={{ display: 'block', fontSize: '0.875rem', fontWeight: 600, color: 'var(--brand-primary, #2563eb)', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 8 }}>
              {c.section_label}
            </span>
          )}
          <InlineEditText
            tag="h2"
            controlKey="headline"
            style={{ fontSize: '2.5rem', marginBottom: 12, letterSpacing: '-0.025em', fontWeight: 700 }}
          >
            {sfHeadline(c, 'Features')}
          </InlineEditText>
          {(sfSub(c) !== undefined || true) && (
            <InlineEditText
              tag="p"
              controlKey="subheadline"
              style={{ fontSize: '1.125rem', color: 'var(--brand-text-light, #64748b)', maxWidth: 640, margin: '0 auto' }}
            >
              {sfSub(c, 'Describe your features here')}
            </InlineEditText>
          )}
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: `repeat(${cols}, 1fr)`, gap: 24 }}>
          {features.map((f, i) => (
            <div key={i} style={{
              background: 'var(--brand-bg, #fff)', border: '1px solid rgba(0,0,0,0.08)',
              borderRadius: 'var(--brand-card-radius, 12px)', padding: 32,
              boxShadow: '0 4px 6px -1px rgba(0,0,0,0.07), 0 2px 4px -2px rgba(0,0,0,0.05)',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            }}>
              <div style={{
                width: 48, height: 48, borderRadius: 12,
                background: 'rgba(37,99,235,0.1)', display: 'flex',
                alignItems: 'center', justifyContent: 'center',
                marginBottom: 16, fontSize: '1.25rem', color: 'var(--brand-primary, #2563eb)',
              }}>
                {renderSbIcon(f.icon, 24) ?? '★'}
              </div>
              <h3 style={{ fontSize: '1.25rem', marginBottom: 8 }}>{f.title}</h3>
              <p style={{ color: 'var(--brand-text-light, #64748b)', lineHeight: 1.6 }}>{f.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesGrid;
